import React from "react";
import { Container, PrimaryDataTable, TableColumn, TableRow } from "@component";
import { Bucket, NumberBucket, SearchResponse } from "@type";

interface Props {
  data?: SearchResponse
  dataCount?: SearchResponse
  isLoading: boolean
}

const TagStatisticsPresenter = ({ data, dataCount, isLoading }: Props) => {
  return (
    <Container>
      <PrimaryDataTable
        title={"카테고리 성향"}
        pagination={false}
        headers={["태그명", "누적횟수", "비율"]}
        useKeyword={true}
        dateType={'date'}
        selectItems={[
          {
            label: '선호/비선호',
            key: 'condition',
            items: [
              {
                label: '선호 태그',
                value: 'POSITIVE'
              },
              {
                label: '비선호 태그',
                value: 'NEGATIVE'
              }
            ]
          }
        ]}
        isLoading={isLoading}>
        {
          data ? data.aggregations.asMap[0].buckets
            .map((bucket: Bucket, index) => {
            const { key, docCount, aggregations } = bucket;
            const { value } = aggregations.asMap[1] as NumberBucket
            const totalCount = dataCount?.aggregations.asMap[0].value
            const percentage = totalCount ? value / totalCount * 100 : 0
            return (
              <TableRow
                key={index}
                enableDetailButton={true}
                enableOverlay={false}
                onClickDetailButton={() => {}}>
                <TableColumn align={"center"}>{ key }</TableColumn>
                <TableColumn align={"center"}>{ value }건</TableColumn>
                <TableColumn align={"center"} percentage={percentage}>{ percentage.toFixed(1) }%</TableColumn>
              </TableRow>
            )
          }) : <></>
        }
      </PrimaryDataTable>
    </Container>
  )
}

export default TagStatisticsPresenter
